import { FileCheck2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const SummaryBar = ({ report }) => {
  const { t } = useLang();
  const s = report.summary || {};
  const zoning = s.zoning;

  return (
    <div
      data-testid="property-check-summary"
      className="relative overflow-hidden rounded-xl border border-primary/25 bg-primary p-6 text-primary-foreground"
    >
      <div className="absolute inset-0 pc-grid opacity-[0.07]" />
      <div className="relative">
        <div className="mb-4 flex items-center gap-2">
          <FileCheck2 className="h-4 w-4 text-accent" />
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-accent">{t("dash.title")}</p>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          <div className="rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/50">{t("sum.permits")}</p>
            <p className="mt-1 font-mono text-2xl font-bold">
              {s.permits?.available === false ? <span className="text-base text-primary-foreground/50">{t("sum.na")}</span> : s.permits?.value ?? 0}
            </p>
          </div>
          <div className="rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/50">{t("sum.openPermits")}</p>
            <p className="mt-1 font-mono text-2xl font-bold">
              {s.open_permits?.available === false ? <span className="text-base text-primary-foreground/50">{t("sum.na")}</span> : s.open_permits?.value ?? 0}
            </p>
          </div>
          <div className="rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/50">{t("sum.violations")}</p>
            <p className="mt-1 font-mono text-2xl font-bold">
              {s.violations?.available === false ? <span className="text-base text-primary-foreground/50">{t("sum.na")}</span> : s.violations?.value ?? 0}
            </p>
          </div>
          <div className="rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/50">{t("sum.openViolations")}</p>
            <p className="mt-1 font-mono text-2xl font-bold">
              {s.open_violations?.available === false ? <span className="text-base text-primary-foreground/50">{t("sum.na")}</span> : s.open_violations?.value ?? 0}
            </p>
          </div>
          <div className="rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/50">{t("sum.failedInspections")}</p>
            <p className="mt-1 font-mono text-2xl font-bold">
              {s.failed_inspections?.available === false ? <span className="text-base text-primary-foreground/50">{t("sum.na")}</span> : s.failed_inspections?.value ?? 0}
            </p>
          </div>
          <div className="rounded-lg border border-accent/50 bg-accent/15 p-3.5">
            <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-primary-foreground/60">{t("sum.zoning")}</p>
            <p className="mt-1 font-mono text-2xl font-bold text-accent" data-testid="summary-zoning">
              {zoning || <span className="text-base text-primary-foreground/50">{t("sum.na")}</span>}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
